import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-toc"
export default class extends Controller {
  static targets = ["button", "content", "icon"]

  connect() {
    this.isOpen = false;

    // Initialize state
    if (this.hasContentTarget && this.hasButtonTarget) {
      this.contentTarget.classList.add('hidden');
      this.buttonTarget.setAttribute('aria-expanded', 'false');
    }
  }

  toggle() {
    this.isOpen = !this.isOpen;

    // Update UI based on state
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', this.isOpen);
    }

    if (this.hasContentTarget) {
      if (this.isOpen) {
        this.contentTarget.classList.remove('hidden');
      } else {
        this.contentTarget.classList.add('hidden');
      }
    }

    if (this.hasIconTarget) {
      if (this.isOpen) {
        this.iconTarget.classList.add('rotate-180');
      } else {
        this.iconTarget.classList.remove('rotate-180');
      }
    }
  }
}
